import React, { useEffect } from 'react'
import '../styles/pageStyles/Home.scss'

import Sidebar from '../components/Sidebar'
import Tablist from '../components/Tablist'
import ContentCard from '../components/ContentCard'

const Home = () => {
    useEffect(() => {
        //   fetch user and get its channelId, in order to pass it to the Tablist compnent.
    }, [])

    return (
        <>
            <div className='home'>
                <Sidebar />
                <div className="home__content-container">
                    <Tablist userId="123" />
                    {/* <div className='home__content-card-container'>
                        <ContentCard />
                        <ContentCard />
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default Home